import {
    APP_USER_PERMISSION_HISTORY_DETAIL_ROUTE,
    APP_USER_PERMISSION_HISTORY_LIST_ROUTE,
} from "config/route-consts";
import { Redirect, Route, Switch } from "react-router-dom";
import AppUserPermissionHistoryList from "./AppUserPermissionHistoryList/AppUserPermissionHistoryList";
import AppUserPermissionHistoryDetail from "./AppUserPermissionHistoryDetail/AppUserPermissionHistoryDetail";

function AppUserPermissionHistoryView() {
    return (
        <Switch>
            <Route
                key={APP_USER_PERMISSION_HISTORY_LIST_ROUTE}
                path={APP_USER_PERMISSION_HISTORY_LIST_ROUTE}
                render={(props: any) => {
                    return <AppUserPermissionHistoryList {...props} />;
                }}
            />
            <Route
                key={APP_USER_PERMISSION_HISTORY_DETAIL_ROUTE}
                path={APP_USER_PERMISSION_HISTORY_DETAIL_ROUTE}
                render={(props: any) => {
                    return <AppUserPermissionHistoryDetail {...props} />;
                }}
            />
            <Redirect to={APP_USER_PERMISSION_HISTORY_LIST_ROUTE} />
        </Switch>
    );
}

export default AppUserPermissionHistoryView;
